import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Typography,
  Switch,
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
} from "@material-tailwind/react";
import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";
import { friendlyTimeFormatDt } from "../../utils";

const functions = getFunctions();

if (window.location.href.indexOf('localhost') > -1) {
    connectFunctionsEmulator(functions, "127.0.0.1", 5001)
}

export default function UserPanel() {

  const [userData, setUserData] = useState([]);

  const getUserStatus = () => {
    const func = httpsCallable(functions, "getUserStatus");
    func().then((data) => {
      setUserData(data.data);
    }).catch((e) => {
      console.error(e)
    })
  }

  useEffect(() => {
    getUserStatus();
  }, []);

  const handleClaimToggle = async (email, claimName, currentValue) => {
    const func = httpsCallable(functions, "setCustomClaims");
    const params = { claimName, email, enabled: !currentValue };
    await func(params);
    getUserStatus();
  };

  const handleDisableToggle = async (userId, currentDisabled) => {
    const func = httpsCallable(functions, currentDisabled ? "enableUser" : "disableUser");
    await func({ uid: userId });
    getUserStatus();
  };

  // Filter users by active/disabled status
  const activeUsers = userData.filter((u) => !u.disabled);
  const disabledUsers = userData.filter((u) => u.disabled);

  const TABLE_HEAD = ["Email", "Last Active", "Disabled", "Admin", "LMA Data", "Report Analytics", "Comps Editor", "User Manage"];

  // Render user table
  const renderUserTable = (userList) => (
    <div className="overflow-x-auto">
      <table className="w-full min-w-[800px] table-auto text-left">
        <thead>
          <tr>
            {TABLE_HEAD.map((head) => (
              <th
                key={head}
                className="border-b border-blue-gray-50 py-3 px-5 text-left"
              >
                <Typography
                  variant="small"
                  className="text-[11px] font-bold uppercase text-blue-gray-400"
                >
                  {head}
                </Typography>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {userList.length === 0 ? (
            <tr>
              <td colSpan={7} className="py-8 text-center">
                <Typography variant="small" className="text-blue-gray-400">
                  No users found
                </Typography>
              </td>
            </tr>
          ) : (
            userList.map(({ userId, email, lastActive, isAdmin, LMAData, reportAnalytics, compsEditor, userManage, disabled }, index) => {
              const isLast = index === userList.length - 1;
              const classes = `py-3 px-5 ${isLast ? "" : "border-b border-blue-gray-50"}`;

              return (
                <tr key={userId}>
                  <td className={classes}>
                    <Typography variant="small" className="font-medium text-blue-gray-600">
                      {email}
                    </Typography>
                  </td>
                  <td className={classes}>
                    <Typography variant="small" className="text-blue-gray-600">
                      {lastActive ? friendlyTimeFormatDt(new Date(lastActive)) : "-"}
                    </Typography>
                  </td>
                  <td className={classes}>
                    <Switch
                      checked={disabled}
                      onChange={() => handleDisableToggle(userId, disabled)}
                      color="red"
                    />
                  </td>
                  <td className={classes}>
                    <Switch
                      checked={isAdmin}
                      onChange={() => handleClaimToggle(email, "admin", isAdmin)}
                      color="amber"
                    />
                  </td>
                  <td className={classes}>
                    <Switch
                      checked={LMAData}
                      onChange={() => handleClaimToggle(email, "LMAData", LMAData)}
                      color="amber"
                    />
                  </td>
                  <td className={classes}>
                    <Switch
                      checked={reportAnalytics}
                      onChange={() => handleClaimToggle(email, "reportAnalytics", reportAnalytics)}
                      color="amber"
                    />
                  </td>
                  <td className={classes}>
                    <Switch
                      checked={compsEditor}
                      onChange={() => handleClaimToggle(email, "compsEditor", compsEditor)}
                      color="amber"
                    />
                  </td>
                  <td className={classes}>
                    <Switch
                      checked={userManage}
                      onChange={() => handleClaimToggle(email, "userManage", userManage)}
                      color="amber"
                    />
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="mt-6">
      <Card>
        <CardHeader className="mb-4 p-6 bg-lma-gold">
          <h2 className="text-xl font-normal tracking-widest uppercase text-white">
            User Data
          </h2>
        </CardHeader>
        <CardBody className="px-0 pt-0 pb-2">
          <Tabs value="active" className="px-4">
            <TabsHeader>
              <Tab value="active">
                Active Users ({activeUsers.length})
              </Tab>
              <Tab value="disabled">
                Disabled Users ({disabledUsers.length})
              </Tab>
            </TabsHeader>
            <TabsBody>
              <TabPanel value="active" className="px-0">
                {renderUserTable(activeUsers)}
              </TabPanel>
              <TabPanel value="disabled" className="px-0">
                {renderUserTable(disabledUsers)}
              </TabPanel>
            </TabsBody>
          </Tabs>
        </CardBody>
      </Card>
    </div>
  );
}
